import { URLStorageProvider } from "./URLStorageProvider.js";
import { LocalStorageProvider } from "./LocalStorageProvider.js";
import { SyncedStorageProvider } from "./SyncedStorageProvider.js";
import { FallbackStorageProvider } from "./FallbackStorageProvider.js";
import { ZipStorageProvider } from "./ZipStorageProvider.js";
import { MemoryStorageProvider } from "./MemoryStorageProvider.js";
import { WatchableStore } from "./WatchableStore.js";
const memoryStorageProvider = new MemoryStorageProvider(/* @__PURE__ */ new Map());
const urlSearchStorageProvider = new URLStorageProvider(
  new URLSearchParams(window.location.search),
  "search"
);
const urlHashStorageProvider = new URLStorageProvider(
  new URLSearchParams(window.location.hash.slice(1)),
  "hash"
);
const urlStorageProvider = urlHashStorageProvider;
const zipUrlStorageProvider = new ZipStorageProvider(urlStorageProvider);
const localStorageProvider = new LocalStorageProvider(window.localStorage);
const syncedStorageProvider = new SyncedStorageProvider(
  urlStorageProvider,
  localStorageProvider
);
const fallbackStorageProvider = new FallbackStorageProvider(
  urlStorageProvider,
  localStorageProvider
);
function createWatchableStore(provider) {
  return new WatchableStore(provider);
}
const memoryStore = createWatchableStore(memoryStorageProvider);
const urlSearchStore = createWatchableStore(urlSearchStorageProvider);
const urlHashStore = createWatchableStore(urlHashStorageProvider);
const urlStore = createWatchableStore(urlStorageProvider);
const zipUrlStore = createWatchableStore(zipUrlStorageProvider);
const localStore = createWatchableStore(localStorageProvider);
const syncedStore = createWatchableStore(syncedStorageProvider);
const fallbackStore = createWatchableStore(fallbackStorageProvider);
export {
  createWatchableStore,
  fallbackStorageProvider,
  fallbackStore,
  localStorageProvider,
  localStore,
  memoryStorageProvider,
  memoryStore,
  syncedStorageProvider,
  syncedStore,
  urlHashStorageProvider,
  urlHashStore,
  urlSearchStorageProvider,
  urlSearchStore,
  urlStorageProvider,
  urlStore,
  zipUrlStorageProvider,
  zipUrlStore
};
//# sourceMappingURL=index.js.map
